
import React from 'react';
import { motion } from 'framer-motion';
import { Control } from 'react-hook-form';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { BasicInfoFields, ContactInfoFields, ClassSelector } from '@/components/registration';

// Base props interface
interface BaseFormRowsProps {
  control: Control<RegistrationFormValues>;
}

// Props for rows that need the year change handler
interface YearChangeProps extends BaseFormRowsProps {
  onYearChange: (year: string | null) => void;
}

// Using the appropriate prop interface for each component
export const BasicInfoRow: React.FC<YearChangeProps> = ({ control, onYearChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <BasicInfoFields control={control} />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <ClassSelector 
          control={control}
          onYearChange={onYearChange}
        />
      </motion.div>
    </div>
  );
};

// ContactInfoRow doesn't use onYearChange, so use the base props
export const ContactInfoRow: React.FC<BaseFormRowsProps> = ({ control }) => {
  return (
    <motion.div 
      className="md:col-span-2 space-y-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3, duration: 0.5 }}
    >
      <ContactInfoFields control={control} />
    </motion.div>
  );
};
